import dayjs from 'dayjs';

import {
  FIRST_PERMITTED_DISCLOSURE,
  PROHIBITED_PERIOD_DISCLOSURE,
  PROHIBITED_UNDER_AGE_16_DISCLOSURE,
  BIRTH_DATE_MISSING,
  SEND_VITAL_SIGNS_ALLOWED_PERIOD,
  ORGANIZATION_RESTRICTION,
  AGENDA_REFERENCE,
  ORGANIZATION_SEND_VITAL_SIGNS_ALLOWED_PERIOD,
  GREATER_AGE_16_ALLOWED,
  SEND_VITAL_SIGNS_PERIOD_MISSING,
  PATIENT_RESTRICTION
} from 'constants.js';

const DATE_FORMAT = 'MMMM DD, YYYY';

const computeRestrictionText = (restriction) => {
  switch (restriction.code) {
    case FIRST_PERMITTED_DISCLOSURE:
      return _computeFirstPermittedDisclosureText(restriction.period);
    case PROHIBITED_PERIOD_DISCLOSURE:
      return _computeProhibitedPeriodDisclosure(restriction.period);
    case PROHIBITED_UNDER_AGE_16_DISCLOSURE:
      return _computeUnderAge16Disclosure();
    case BIRTH_DATE_MISSING:
      return _computeBirthDateMissing();
    case SEND_VITAL_SIGNS_ALLOWED_PERIOD:
      return _computeSendVitalSignsAllowedPeriodText(restriction.period);
    case ORGANIZATION_RESTRICTION:
      return _computeOrganizationRestrictionText(restriction.restrictedById);
    case AGENDA_REFERENCE:
      return _computeAgendaRestrictionText(restriction.restrictedById, restriction.period);
    case ORGANIZATION_SEND_VITAL_SIGNS_ALLOWED_PERIOD:
      return _computeOrganizationSendVitalSignsAllowedPeriodText(restriction.restrictedById);
    case GREATER_AGE_16_ALLOWED:
      return _computeUnderAge16Disclosure();
    case SEND_VITAL_SIGNS_PERIOD_MISSING:
      return _computeSendVitalSignsPeriodMissing();
    default:
      return '';
  }
};

const computeResourceRestrictionByPatientText = (restrictionCode) => {
  switch (restrictionCode) {
    case ORGANIZATION_RESTRICTION:
      return _computeResourceByOrganizationRestrictionText();
    case PATIENT_RESTRICTION:
      return _computeResourceByPatientRestrictionText();
    default:
      return '';
  }
};

const _computeSendVitalSignsAllowedPeriodText = ({start, end}) =>
  `Sending vital signs is allowed${start ? ` from ${dayjs(start).format(DATE_FORMAT)}` : ''} ${
    end ? `to ${dayjs(end).format(DATE_FORMAT)}` : ''
  }`;

const _computeFirstPermittedDisclosureText = ({start}) => `First permitted from ${dayjs(start).format(DATE_FORMAT)}`;

const _computeProhibitedPeriodDisclosure = ({start, end}) =>
  `Disclosure prohibited${start ? ` from ${dayjs(start).format(DATE_FORMAT)}` : ''} ${
    end ? `to ${dayjs(end).format(DATE_FORMAT)}` : ''
  }`;

const _computeUnderAge16Disclosure = () => 'Patient is younger than 16';

const _computeBirthDateMissing = () => 'Date of birth was not provided';

const _computeOrganizationRestrictionText = (organizationId) =>
  `Organization with ID '${organizationId}' has active restrictions`;

const _computeAgendaRestrictionText = (agendaId, agendaPeriod) =>
  `Agenda resource 'Basic/${agendaId}' has active restriction ${
    agendaPeriod.start ? `from ${dayjs(agendaPeriod.start).format(DATE_FORMAT)}` : ''
  } ${agendaPeriod.end ? `to ${dayjs(agendaPeriod.end).format(DATE_FORMAT)}` : ''}`;

const _computeOrganizationSendVitalSignsAllowedPeriodText = (organizationId) =>
  `Organization with ID '${organizationId}' has inactive data send allowances`;

const _computeSendVitalSignsPeriodMissing = () => 'Send vital signs period was not provided';

const _computeResourceByOrganizationRestrictionText = () => 'Resource is restricted by Organization restrictions';

const _computeResourceByPatientRestrictionText = () => 'Resource is restricted by Patient restrictions';

const isDefined = (obj) => {
  return (obj || null) !== null;
};

const areDefined = (...objs) => {
  return objs.filter((obj) => !isDefined(obj)).length === 0;
};

const isEmpty = (obj) => {
  return !isDefined(obj);
};

const areScopesAvailable = (rights) => {
  return rights.search || rights.reports;
};

export {
  areDefined,
  isEmpty,
  isDefined,
  computeRestrictionText,
  computeResourceRestrictionByPatientText,
  areScopesAvailable
};
